import { token } from 'services/LocalStorage/localStorage';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getAccessToken.query';

export const getUuid = (params: QueryParams) => {
    const uuid = params.uuid;
    const url = `api/bo/getUuid?uuid=${uuid}`;
    return network.post(url, params).then((response) => {
        token.set(response.data.attribute);
        network.defaults.headers.common['Authorization'] = `Bearer ${response.data.attribute}`;
        return {
            username: response.data.username,
        };
    });
};
